import { tasks_ancestry } from '../application/javascript/tasks.js.erb';

export { tasks_ancestry }
